<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    v-model="username"
                    placeholder="Username"
                    autocomplete="username email"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    v-model="password"
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CRow class="justify-content-center">
                    <CCol col="6" class="text-left">
                      <CButton block color="primary" v-on:click="login" class="px-4 m-3">LOGIN</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>

          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
  import Vue from "vue";

  export default {
  name: 'Login',
    beforeCreate() {
      console.log(this.$session);
      if(this.$session.get('token')){
        this.$router.push("/dashboard")
      }
    },
    data() {
      return {
        username:"",
        password:""
      }
    },

    methods:{
    async login() {
      const response = await Vue.axios.post('/businessUser/login', {
        "username": this.username,
        "password": this.password
      });
      console.log(response)
      console.log(response.data)
      if (response.data.resultCode === 100) {
        console.log(response.data.data)
        await this.saveSession(response.data.data);
        console.log("Saved")
        location.href = "/"
        // await this.$router.push("/")
      } else {
        console.log(response.data.error)
        alert(response.data.error)
      }
    },
    async saveSession(data) {
      this.$session.start()
      await this.$session.set('token', data.token)
      await this.$session.set('user', data)
      console.log("Token = " + Vue.prototype.$session.get('token'))
    }
  }
}
</script>
